import { render, staticRenderFns } from "./LeaderboardRow.vue?vue&type=template&id=380fc0e6&scoped=true&"
import script from "./LeaderboardRow.vue?vue&type=script&lang=js&"
export * from "./LeaderboardRow.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardRow.vue?vue&type=style&index=0&id=380fc0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fc0e6",
  null
  
)

export default component.exports